import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppContextAction, CoreUiInteractionEvent, ProductType, UiInteractionAction } from "@obg/ngx.core";
import { MenuItem, MenuSelector } from "@obg/ngx.core.content";
import { isExternalUrl } from "@obg/ngx.global";
import { RouteAction, RouteLink, RouteLinkService, RouterState, RouteSelector } from "@obg/ngx.router";
import { ignoreEmpty } from "@obg/rxjs";
import { combineLatest } from "rxjs";
import { map, tap } from "rxjs/operators";

import { TrackingContext } from "../../tracking/tracking.model";

@Component({
	selector: "obg-product-selector-wrapper-container",
	templateUrl: "./product-selector-wrapper.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ProductSelectorWrapperContainer {
	activeTabKey = "";

	productMenu$ = combineLatest([
		this.store.select(MenuSelector.get("product-menu")).pipe(
			map((menu) => menu?.items),
			ignoreEmpty()
		),
		this.store.pipe(RouteSelector.getCurrent$),
	]).pipe(
		tap(([items, current]) => {
			const currentMenuItem = items.find((item) => item.route === current.name);
			this.activeTabKey = currentMenuItem?.key || "";
		}),
		map(([items]) =>
			items.map((item) => ({
				...item,
				href: this.routeLinkService.getUrl(this.getRouteLink(item)),
			}))
		)
	);

	constructor(
		private appContextAction: AppContextAction,
		private routeLinkService: RouteLinkService,
		private store: Store<RouterState>,
		private uiInteractionAction: UiInteractionAction
	) {}

	getRouteLink(item: MenuItem): RouteLink {
		return {
			route: item.route,
			url: item.link?.url,
		};
	}

	onTabClicked({ detail: item }: CustomEvent<MenuItem & { href: string }>) {
		const routeLink = this.getRouteLink(item);
		const { route, url } = routeLink;

		this.store.dispatch(
			this.uiInteractionAction.emit({
				context: TrackingContext.ProductSelectorInteractionContext,
				event: CoreUiInteractionEvent.LobbyChange,
				data: { ItemClicked: item.key },
			})
		);

		if (item.link?.url && isExternalUrl(item.link.url)) {
			this.store.dispatch(this.appContextAction.setProduct(ProductType.Common));
		}

		setTimeout(() => {
			if (route) {
				this.store.dispatch(RouteAction.navigate(route));
			} else if (url) {
				this.store.dispatch(RouteAction.navigateByUrl(url));
			}
		});
	}
}
